import { Component, OnInit } from '@angular/core';
import { RestApiService } from "../shared/restApiServices/restapi.service";
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import { PlanService } from "../shared/services/planService";
import { isUndefined } from 'util';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-gstinvoicedetails',
  templateUrl: './gstinvoicedetails.component.html',
  styleUrls: ['./gstinvoicedetails.component.css']
})
export class GstinvoicedetailsComponent implements OnInit {
    email;
    place;
    place1;
    customername;
    subscriptionid;
    gstinnumber;
    gstinnumber1;
    address;
    loader:boolean = false;

  constructor( public dialogRef:MatDialogRef<GstinvoicedetailsComponent>,private restApiService:RestApiService,private toastyService:ToastyService, private toastyConfig: ToastyConfig,private planService:PlanService){
    this.restApiService.getgstDetails().subscribe(res=>{
        this.place = res.placeOfSupply;
        this.gstinnumber = res.GSTIN;
    })
   }

  detailsubmit()
  {
      this.loader = true;
      this.gstinnumber1 = '';
      this.place1 = '';

      if(this.gstinnumber==null || isUndefined(this.gstinnumber) || this.gstinnumber=="")
      {
        this.gstinnumber1 = "on-error";
        return;
      }
      else if(this.place==null || isUndefined(this.place) || this.place=="")
      {
        this.place1 = "on-error";
        return;
      }
      else {
        this.gstinnumber1 = '';
        this.place1 = '';
      }

    this.restApiService.getPlanAndAccountDetailsOfUser().subscribe(res=>{
      if(res && res.success == true){
        // console.log(JSON.stringify(res));
        this.email= res.userEmail;
        this.customername = res.Name;
        this.subscriptionid = this.planService.getSubscription();
        this.address = res.data[0].address;
        this.subscriptionid = res.data[0].razorpay_subscription_id;
        this.restApiService.sendmailgstinvoice(this.email,this.place,this.customername,this.subscriptionid,this.gstinnumber,this.address).subscribe(res =>{
        this.loader = false;
          if(res == "Successfully sent")
          {
            var toastOptions:ToastOptions = {
              title: "Request received.",
              msg: "Please expect GST invoice in 48 hours.",
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.success(toastOptions);
            this.dialogRef.close();
          }
          else
          {
            var toastOptions:ToastOptions = {
              title: "Oops! Something went wrong",
              msg: "Please refresh the page and try again.",
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.success(toastOptions);
          }
        })
      }
    });

    this.restApiService.updategstdetails(this.place, this.gstinnumber).subscribe(res=>{
      if(res.success == true){
      }
      else{
      }
  })

  }
  ngOnInit() {

  }

  onClose(){
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/gstinvoicedetails/gstinvoicedetails.component.ts